import { AppShell } from '../components/AppShell'
import { useAuth } from '../lib/auth'
import { fmtDateTime, fmtEur } from '../lib/format'

const STEPS = [
  { key: 'p1',       label: 'Phase 1 completed',          done: true,  meta: 'Profit target reached.' },
  { key: 'p2',       label: 'Phase 2 completed',          done: true,  meta: 'Verification target reached.' },
  { key: 'kyc',      label: 'KYC verification',           done: false, meta: 'Identity and proof of address.' },
  { key: 'audit',    label: 'Internal audit',             done: false, meta: 'Trade history review by ops.' },
  { key: 'contract', label: 'Funded contract signing',    done: false, meta: 'Final agreement before funding.' },
]

const CARD: React.CSSProperties = {
  background: 'var(--bg-surface)',
  border: '1px solid var(--border-subtle)',
  borderRadius: 'var(--radius-md)',
  padding: 'var(--space-5)',
}

export function Phase3View() {
  const { account } = useAuth()
  return (
    <AppShell>
      <header className="page-header">
        <div className="page-header__title-row">
          <h1 className="page-header__title">Phase 3 — Review</h1>
          <span className="page-header__subtitle">You passed P1 and P2. KYC and internal audit remain.</span>
        </div>
      </header>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 'var(--space-5)' }}>
        <section style={CARD}>
          <h3 style={{ margin: '0 0 var(--space-4)', fontSize: 'var(--text-md)', fontWeight: 'var(--weight-semibold)' }}>Progress</h3>
          <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
            {STEPS.map((s, i) => (
              <li key={s.key} style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--space-3)' }}>
                <span
                  style={{
                    flex: '0 0 28px',
                    width: 28, height: 28,
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'var(--text-sm)',
                    fontWeight: 700,
                    background: s.done ? 'var(--color-success-subtle)' : 'var(--bg-subtle)',
                    color:      s.done ? 'var(--color-success-text)'   : 'var(--text-tertiary)',
                    fontFamily: 'var(--font-mono)',
                  }}
                >
                  {s.done ? '✓' : i + 1}
                </span>
                <div>
                  <div style={{ fontSize: 'var(--text-sm)', fontWeight: 600 }}>{s.label}</div>
                  <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                    {s.done ? 'Done' : s.meta}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </section>

        <section style={CARD}>
          <h3 style={{ margin: '0 0 var(--space-4)', fontSize: 'var(--text-md)', fontWeight: 'var(--weight-semibold)' }}>Summary</h3>
          <dl style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', fontSize: 'var(--text-sm)', margin: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <dt style={{ color: 'var(--text-tertiary)' }}>Tier</dt>
              <dd style={{ fontWeight: 600 }}>{account?.tierCode?.toUpperCase() ?? '—'}</dd>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <dt style={{ color: 'var(--text-tertiary)' }}>Starting balance</dt>
              <dd style={{ fontWeight: 600 }}>{fmtEur(account?.startingBalance)}</dd>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <dt style={{ color: 'var(--text-tertiary)' }}>Current balance</dt>
              <dd style={{ fontWeight: 600 }}>{fmtEur(account?.currentBalance)}</dd>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <dt style={{ color: 'var(--text-tertiary)' }}>Started</dt>
              <dd style={{ fontWeight: 600 }}>{fmtDateTime(account?.startedAt)}</dd>
            </div>
          </dl>
        </section>
      </div>
    </AppShell>
  )
}
